import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "py-4 sm:py-8 sm:p-8" }
const _hoisted_2 = { class: "mb-10 flex items-center justify-between" }
const _hoisted_3 = { class: "mb-6 flex items-center justify-between flex-wrap gap-4" }
const _hoisted_4 = { class: "flex flex-wrap items-center gap-4" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = { class: "flex items-center gap-2" }
const _hoisted_7 = { class: "text-xs text-zinc-300" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "flex items-center gap-2 flex-wrap" }
const _hoisted_10 = {
  key: 0,
  class: "text-xs text-red-400 flex items-center gap-2"
}
const _hoisted_11 = { class: "flex items-center gap-1.5 flex-wrap max-w-[200px]" }
const _hoisted_12 = {
  key: 1,
  class: "text-[10px] text-zinc-500 italic"
}
const _hoisted_13 = { class: "flex justify-end gap-2" }
const _hoisted_14 = {
  key: 0,
  class: "space-y-4 md:hidden text-left"
}
const _hoisted_15 = { class: "flex items-center gap-2" }
const _hoisted_16 = { class: "flex flex-col" }
const _hoisted_17 = { class: "flex items-center gap-2" }
const _hoisted_18 = { class: "text-white font-bold text-lg" }
const _hoisted_19 = { class: "flex flex-col items-end gap-2" }
const _hoisted_20 = { class: "flex items-center gap-1" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_24 = { class: "text-xs text-zinc-500 block" }
const _hoisted_25 = {
  key: 0,
  class: "flex flex-wrap gap-1"
}
const _hoisted_26 = {
  key: 1,
  class: "text-xs text-red-400 flex items-center gap-1 mt-1"
}
const _hoisted_27 = { class: "flex flex-wrap gap-1" }
const _hoisted_28 = { class: "flex items-center justify-between pt-2" }
const _hoisted_29 = { class: "flex flex-col" }
const _hoisted_30 = {
  key: 1,
  class: "text-center py-12 text-zinc-500"
}
const _hoisted_31 = { class: "flex items-center gap-1" }
const _hoisted_32 = { class: "inline-block" }
const _hoisted_33 = { class: "flex items-center gap-1" }
const _hoisted_34 = { class: "flex items-center gap-1" }
const _hoisted_35 = { class: "flex items-center gap-1" }
const _hoisted_36 = { class: "flex items-center gap-1" }
const _hoisted_37 = { class: "grid grid-cols-2 gap-6 py-4" }
const _hoisted_38 = { class: "grid gap-2 col-span-full" }
const _hoisted_39 = { class: "grid gap-2 col-span-full" }
const _hoisted_40 = { class: "relative" }
const _hoisted_41 = {
  key: 0,
  class: "grid gap-2 col-span-full sm:col-span-1"
}
const _hoisted_42 = { class: "flex justify-between items-center gap-2" }
const _hoisted_43 = {
  key: 0,
  class: "text-zinc-400 text-xs"
}
const _hoisted_44 = { class: "grid gap-2 col-span-full" }
const _hoisted_45 = { class: "flex items-center gap-2" }
const _hoisted_46 = { class: "grid gap-2 col-span-full" }
const _hoisted_47 = { class: "grid gap-2 col-span-full" }
const _hoisted_48 = { class: "flex items-center gap-3" }
const _hoisted_49 = { class: "grid gap-2 col-span-full" }
const _hoisted_50 = { class: "grid gap-2 col-span-full" }
const _hoisted_51 = { class: "flex gap-2 flex-wrap items-center px-3" }
const _hoisted_52 = { class: "grid grid-cols-1 gap-6 py-4" }
const _hoisted_53 = { class: "grid gap-3" }
const _hoisted_54 = {
  key: 0,
  class: "flex items-center justify-center p-4"
}
const _hoisted_55 = {
  key: 1,
  class: "flex items-center justify-center p-4"
}
const _hoisted_56 = {
  key: 0,
  class: "text-xs text-yellow-400 pt-2 flex items-center gap-2"
}
const _hoisted_57 = {
  key: 0,
  class: "grid gap-3"
}
const _hoisted_58 = {
  key: 0,
  class: "flex items-center justify-center p-4"
}
const _hoisted_59 = {
  key: 1,
  class: "flex items-center justify-center p-4"
}
const _hoisted_60 = { class: "grid gap-2 col-span-full" }
const _hoisted_61 = {
  key: 0,
  class: "text-xs text-yellow-400 pt-2 flex items-center gap-2"
}
const _hoisted_62 = { class: "flex items-center gap-2 pt-2" }
const _hoisted_63 = { class: "grid grid-cols-2 gap-6 py-4" }
const _hoisted_64 = { class: "grid gap-2 col-span-full" }
const _hoisted_65 = { class: "grid gap-2 col-span-full" }
const _hoisted_66 = { class: "flex gap-2 flex-wrap items-center px-3" }
const _hoisted_67 = { class: "grid gap-2 col-span-full" }
const _hoisted_68 = { class: "flex gap-2 flex-wrap items-center px-3" }
const _hoisted_69 = { class: "flex gap-6 col-span-full" }
const _hoisted_70 = { class: "flex items-center gap-2" }
const _hoisted_71 = { class: "grid gap-2 col-span-full py-4" }
const _hoisted_72 = { class: "flex gap-2 flex-wrap items-center px-3" }
const _hoisted_73 = { class: "grid gap-2 col-span-full py-4" }
const _hoisted_74 = { class: "flex gap-2 flex-wrap items-center px-3" }
const _hoisted_75 = { class: "space-y-6 py-4" }
const _hoisted_76 = { class: "flex items-center justify-between" }
const _hoisted_77 = {
  key: 0,
  class: "space-y-6 animate-in fade-in slide-in-from-top-2 duration-300"
}
const _hoisted_78 = { class: "grid md:grid-cols-2 gap-6" }
const _hoisted_79 = { class: "space-y-6" }
const _hoisted_80 = { class: "flex flex-col gap-2" }
const _hoisted_81 = { class: "flex flex-col gap-2" }
const _hoisted_82 = { class: "grid gap-2" }
const _hoisted_83 = { class: "space-y-6" }
const _hoisted_84 = { class: "grid gap-2" }
const _hoisted_85 = { class: "flex gap-2 flex-wrap items-center px-3" }
const _hoisted_86 = { class: "grid gap-2" }
const _hoisted_87 = { class: "flex gap-2 flex-wrap items-center px-3" }
const _hoisted_88 = { class: "grid gap-2" }
const _hoisted_89 = { class: "flex gap-2 flex-wrap items-center px-3" }
const _hoisted_90 = { class: "grid gap-2" }
const _hoisted_91 = { class: "flex items-center gap-3" }
const _hoisted_92 = { class: "grid gap-0.5" }
const _hoisted_93 = { class: "flex items-center justify-end gap-3 pt-4 border-t border-zinc-800" }
const _hoisted_94 = { class: "border border-zinc-800 rounded-xl overflow-hidden bg-zinc-950/50" }
const _hoisted_95 = { class: "flex justify-end gap-2" }
const _hoisted_96 = { class: "flex flex-col items-center gap-2" }

import { ref, onMounted, watch, computed } from 'vue'
import {
  MagnifyingGlassIcon,
  ArrowsUpDownIcon,
  CreditCardIcon,
  PencilIcon,
  // CopyIcon,
  TrashIcon,
} from '@heroicons/vue/24/outline'
import MobileCard from '@/components/ui/mobile-card/MobileCard.vue'
import MobileDataLabel from '@/components/ui/mobile-card/MobileDataLabel.vue'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogScrollContent,
  DialogTitle,
} from '@/components/ui/dialog'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import RegisterButton from '@/components/ui/register-button/RegisterButton.vue'
import Table from '@/components/ui/table/Table.vue'
import TableHeader from '@/components/ui/table/TableHeader.vue'
import TableRow from '@/components/ui/table/TableRow.vue'
import TableHead from '@/components/ui/table/TableHead.vue'
import TableBody from '@/components/ui/table/TableBody.vue'
import TableFallback from '@/components/ui/table/TableFallback.vue'
import TableCell from '@/components/ui/table/TableCell.vue'
import Pagination from '@/components/ui/pagination/Pagination.vue'
import TableContainer from '@/components/ui/table/TableContainer.vue'
import { CreatePaymentPlanDTO, GetAllPaymentPlansParams, UpdatePaymentPlanDTO, usePaymentPlan } from '@/composables/usePaymentPlan'
import { Pagination as IPagination } from '@/interfaces/Pagination'
import { PaymentPlan } from '@/interfaces/PaymentPlan'
import TableRowSkeleton from '@/components/ui/table/TableRowSkeleton.vue'
import { PaymentPlanTypeEnum, PaymentPlanTypeLabels } from '@/enums/payment-plans/PaymentPlanTypeEnum'
import { useToast } from '@/components/ui/toast'
import { ArrowDown, ArrowUp, CircleHelp, DollarSign, HelpCircle, Info, Loader2, PlusIcon } from 'lucide-vue-next'
import DeleteConfirmationDialog from '@/components/ui/delete-dialog/DeleteConfirmationDialog.vue'
import { PaymentPlanStatusEnum, PaymentPlanStatusLabels } from '@/enums/payment-plans/PaymentPlanStatusEnum'
import PageTitle from '@/components/ui/page/PageTitle.vue'
import PageDescription from '@/components/ui/page/PageDescription.vue'
import { Textarea } from '@/components/ui/textarea'
import { ComboboxAnchor, ComboboxContent, ComboboxInput, ComboboxPortal, ComboboxRoot } from 'radix-vue'
import { CommandEmpty, CommandGroup, CommandItem, CommandList } from '@/components/ui/command'
import { TagsInput, TagsInputInput, TagsInputItem, TagsInputItemDelete, TagsInputItemText } from '@/components/ui/tags-input'
import { useButton } from '@/composables/useButton'
import { Button as IButton } from '@/interfaces/Button'
import { Switch } from '@/components/ui/switch'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { useVariant } from '@/composables/useVariant'
import { Variant } from '@/interfaces/products/variants/Variant'
import { Product } from '@/interfaces/products/Product'
import { useProduct } from '@/composables/useProduct'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import StatusBadge from '@/components/ui/badge/StatusBadge.vue'
import { IntegrationEnum } from '@/enums/products/integrations/IntegrationEnum'
import { Badge } from '@/components/ui/badge'
import { MessageRecipientTypeEnum } from '@/enums/messages/MessageRecipientTypeEnum'
import { useMessage } from '@/composables/useMessage'
import { useTime } from '@/composables/useTime'
import { Trash } from 'lucide-vue-next'
import AnyFileUpload from '@/components/ui/upload/AnyFileUpload.vue'
import TimePicker from '@/components/ui/time/TimePicker.vue'
import RichTextarea from '@/components/ui/textarea/RichTextarea.vue'
import { useVideoCall } from '@/composables/useVideoCall'
import { Phone } from 'lucide-vue-next'

// Table Configuration
import { useOrderBump } from '@/composables/useOrderBump'
import { OrderBump } from '@/interfaces/OrderBump'
import { MessageMedia } from '@/interfaces/messages/MessageMedia'

import { useGroup } from '@/composables/useGroup'
import { Group } from '@/interfaces/Group'


export default /*@__PURE__*/_defineComponent({
  __name: 'ManagePaymentPlansView',
  setup(__props) {

const tableHeaders = [
  { key: 'buttonMessage', label: 'Mensagem do Botão', sortable: false },
  { key: 'value', label: 'Valor/Tipo', sortable: false },
  { key: 'bindings', label: 'Vinculos', sortable: false },
  { key: 'downsells', label: 'Downsells', sortable: false },
  { key: 'status', label: 'Status', sortable: false },
  { key: 'actions', label: '', class: 'w-32' },
]

const planTab = ref('general')

// Filters
const searchQuery = ref('')
const typeFilter = ref('all')

const { getById, getAll, create, update, destroy } = usePaymentPlan()
const isSaving = ref(false)

// Sample data (empty for demo)
const paymentPlans = ref<IPagination<PaymentPlan>>()
const { toast } = useToast()

// Dialog and Form
const isPlanDialogOpen = ref(false)
const isPlanDialogLoading = ref(false)
const editingPlan = ref<PaymentPlan | null>(null)
const deletingPLan = ref<number>()
const isDeletingPlan = ref(false)
const planForm = ref<Partial<CreatePaymentPlanDTO & UpdatePaymentPlanDTO & { videoCallIds: number[], groupIds: number[] }>>({ cycle: 1, upsellPaymentPlanIds: [], upsellButtonIds: [], videoCallIds: [], groupIds: [] })
const isDeletePlanDialogOpen = ref(false)
const perPage = ref('25')
const upsell = ref(false)

// Downsell Logic
const { create: createMessage, destroy: destroyMessage, update: updateMessage } = useMessage()
const { intervalToHHMM, convertIntervalToSeconds } = useTime()
const isAddingDownsell = ref(false)
const isSavingDownsell = ref(false)
const editingDownsellId = ref<number | null>(null)
const downsellForm = ref<Partial<any>>({
  description: '',
  message: '',
  recipientType: MessageRecipientTypeEnum.DOWNSELL,
  abandonedChat: false,
  sendingInterval: 3600, // 1 hour default
  paymentPlanIds: [],
  buttonIds: [],
  downsellPaymentPlanIds: []
})

const isDeleteDownsellDialogOpen = ref(false)
const deletingDownsellId = ref<number | null>(null)
const isDeletingDownsell = ref(false)
const downsellIntervalTime = ref('01:00')

// Downsell Multi-selects
const downsellPaymentPlanNames = ref<string[]>([])
const searchDownsellPaymentPlan = ref('')
const isDownsellPaymentPlanComboboxOpen = ref(false)
const downsellButtonNames = ref<string[]>([])
const searchDownsellButton = ref('')
const isDownsellButtonComboboxOpen = ref(false)

// Downsell Media
const downsellStartMedia = ref<File | null>(null)
const downsellStartMediaPreview = ref<string | null>(null)

const startMediaInputDownsell = ref<HTMLInputElement | null>(null)

const handleDownsellMediaChange = (event: Event, type: 'start') => {
  const file = (event.target as HTMLInputElement).files?.[0]
  if (file) {
    downsellStartMedia.value = file
    downsellStartMediaPreview.value = URL.createObjectURL(file)
  }
}

watch(() => downsellIntervalTime.value, (val) => {
  const [hours, minutes] = val.split(':').map(Number)
  downsellForm.value.sendingInterval = (hours * 3600) + (minutes * 60)
})

const openNewDownsellForm = () => {
  isAddingDownsell.value = true
  downsellForm.value = {
    description: '',
    message: '',
    recipientType: MessageRecipientTypeEnum.DOWNSELL,
    abandonedChat: false,
    sendingInterval: 3600,
    paymentPlanIds: [],
    buttonIds: [],
    downsellPaymentPlanIds: [String(editingPlan.value?.id)],
    hasSpoiler: false
  }
  downsellIntervalTime.value = '01:00'
  downsellPaymentPlanNames.value = [editingPlan.value?.name ?? '']
  downsellButtonNames.value = []
  paymentPlanNamesInDownsell.value = []
}

const saveDownsell = async () => {
  if (!editingPlan.value) return
  isSavingDownsell.value = true
  
  const payload: any = {
    ...downsellForm.value,
    status: 'active',
    sendAt: new Date(),
  }

  if (downsellStartMedia.value) payload.startMedia = downsellStartMedia.value
  
  try {
    if (editingDownsellId.value) {
      // Re-map IDs for update
      payload.paymentPlanIds = downsellForm.value.paymentPlanIds
      payload.buttonIds = downsellForm.value.buttonIds
      delete payload.recipientType
      await updateMessage(editingDownsellId.value, payload)
      toast({ title: 'Downsell atualizado com sucesso', class: 'bg-green-500 text-white' })
    } else {
      await createMessage(payload)
      toast({ title: 'Downsell criado com sucesso', class: 'bg-green-500 text-white' })
    }
    
    isSavingDownsell.value = false
    cancelDownsellEdit()
    const data = await getById(editingPlan.value!.id)
    editingPlan.value = data
  } catch (error) {
    isSavingDownsell.value = false
  }
}

const cancelDownsellEdit = () => {
  isAddingDownsell.value = false
  editingDownsellId.value = null
  downsellForm.value = {
    description: '',
    message: '',
    recipientType: MessageRecipientTypeEnum.DOWNSELL,
    abandonedChat: false,
    sendingInterval: 3600,
    paymentPlanIds: [],
    buttonIds: [],
    downsellPaymentPlanIds: [],
    hasSpoiler: false
  }
  downsellIntervalTime.value = '01:00'
  downsellPaymentPlanNames.value = []
  downsellButtonNames.value = []
  downsellStartMedia.value = null
  downsellStartMediaPreview.value = null
}

const editDownsell = (ds: any) => {
  editingDownsellId.value = ds.id
  isAddingDownsell.value = true
  downsellForm.value = {
    description: ds.description,
    message: ds.message,
    recipientType: ds.recipientType,
    abandonedChat: ds.abandonedChat,
    sendingInterval: ds.sendingInterval ? convertIntervalToSeconds(ds.sendingInterval) : 0,
    paymentPlanIds: (ds.paymentPlans ?? []).map((p: any) => String(p.id)),
    buttonIds: (ds.buttons ?? []).map((b: any) => String(b.id)),
    downsellPaymentPlanIds: (ds.downsellPaymentPlans ?? []).map((p: any) => String(p.id))
  }
  downsellIntervalTime.value = intervalToHHMM(ds.sendingInterval) || '01:00'
  downsellPaymentPlanNames.value = (ds.downsellPaymentPlans ?? []).map((p: any) => p.name)
  downsellButtonNames.value = (ds.buttons ?? []).map((b: any) => b.name)
  // These names are for the "Plans" selection (upsell/offers)
  paymentPlanNamesInDownsell.value = (ds.paymentPlans ?? []).map((p: any) => p.name)
  
  // Previews
  downsellStartMediaPreview.value = ds.media?.find((m: MessageMedia) => m.placement === 'start')?.source || ds.media?.find((m: MessageMedia) => m.placement === 'top')?.source || null
}

const removeDownsell = async (id: number) => {
  deletingDownsellId.value = id
  isDeleteDownsellDialogOpen.value = true
}

const confirmDeleteDownsell = async () => {
  if (!deletingDownsellId.value) return
  
  try {
    isDeletingDownsell.value = true
    await destroyMessage(deletingDownsellId.value)
    toast({ title: 'Downsell removido', class: 'bg-green-500 text-white' })
    if (editingPlan.value) {
      const data = await getById(editingPlan.value.id)
      editingPlan.value = data
    }
    isDeleteDownsellDialogOpen.value = false
    deletingDownsellId.value = null
  } catch (error) {
    // console.log(error)
  } finally {
    isDeletingDownsell.value = false
  }
}

const searchPaymentPlan = ref('')
const { getAll: getAllButtons } = useButton()
const buttons = ref<IPagination<IButton>>()
const isButtonComboboxOpen = ref(false)
const filteredButtons = computed(() => buttons.value?.data.filter(i => !planForm.value.upsellButtonIds?.includes(i.id)))
const searchButton = ref('')
const buttonNames = ref<string[]>([])
const paymentPlanNamesInDownsell = ref<string[]>([])

const filteredPaymentPlans = computed(() => paymentPlans.value?.data.filter(i => !planForm.value.upsellPaymentPlanIds?.includes(i.id) && i.status !== PaymentPlanStatusEnum.INACTIVE))

const filteredDownsellButtons = computed(() => buttons.value?.data.filter(i => !downsellForm.value.buttonIds?.includes(String(i.id))))

const filteredDownsellPaymentPlans = computed(() => {
  return paymentPlans.value?.data.filter(i => 
    !downsellForm.value.downsellPaymentPlanIds?.includes(String(i.id)) && 
    i.status !== PaymentPlanStatusEnum.INACTIVE
  )
})

const filteredPlansForDownsellBody = computed(() => {
  return paymentPlans.value?.data.filter(i => 
    !downsellForm.value.paymentPlanIds?.includes(String(i.id)) && 
    i.status !== PaymentPlanStatusEnum.INACTIVE
  )
})

const products = ref<IPagination<Product>>()
const variants = ref<Variant[]>()
const { getAll: getAllProducts } = useProduct()
const { getAllByProductId: getAllVariantsByProductId } = useVariant()
const isVariantsLoading = ref(false)

const changeProductId = async (_productId: number) => {
  isVariantsLoading.value = true
  planForm.value.productId = _productId
  variants.value = await getAllVariantsByProductId(_productId)
  isVariantsLoading.value = false
}

const createProduct = () => {
  if (window.top) window.top.location.href = 'https://dashboard.hoopay.com.br/products/products_new'
}

// Order Bumps Logic
const { getAll: getAllOrderBumps } = useOrderBump()
const orderBumps = ref<OrderBump[]>([])
const filteredOrderBumps = computed(() => orderBumps.value?.filter(i => !planForm.value.orderBumpIds?.includes(i.id)))
const searchOrderBump = ref('')
const isOrderBumpComboboxOpen = ref(false)
const orderBumpNames = ref<string[]>([])

const isPaymentPlanComboboxOpen = ref(false)
const paymentPlanNames = ref<string[]>([])

const loadOrderBumps = async () => {
    orderBumps.value = await getAllOrderBumps()
}

// Video Call Logic
const { fetchBotVideoCalls } = useVideoCall()
const videoCalls = ref<IVideoCall[]>([])
const filteredVideoCalls = computed(() => videoCalls.value?.filter(i => !planForm.value.videoCallIds?.includes(i.id)))
const searchVideoCall = ref('')
const isVideoCallComboboxOpen = ref(false)
const videoCallNames = ref<string[]>([])

const loadVideoCalls = async () => {
    if (editingPlan.value?.botId) {
        videoCalls.value = await fetchBotVideoCalls(editingPlan.value.botId)
    } else {
        // Find botId from paymentPlans if possible, or use one from current filters
        // For simplicity, we can fetch all or handle it in openDialog
    }
}


const createVariant = () => {
  if (window.top) window.top.location.href = 'https://dashboard.hoopay.com.br/products/edit/' + planForm.value.productId
}

// Group Logic
const { getAll: getAllGroups } = useGroup()
const groups = ref<Group[]>([])
const filteredGroups = computed(() => groups.value?.filter(i => !planForm.value.groupIds?.includes(i.id)))
const searchGroup = ref('')
const isGroupComboboxOpen = ref(false)
const groupNames = ref<string[]>([])

const loadGroups = async () => {
    const data = await getAllGroups({ perPage: '100' })
    if ('data' in data) {
      groups.value = data.data
    } else {
      groups.value = data
    }
}

// Actions
const openNewPlanDialog = () => {
  planForm.value.productId = undefined
  variants.value = undefined
  upsell.value = false
  paymentPlanNames.value = []
  buttonNames.value = []
  orderBumpNames.value = []
  videoCallNames.value = []
  groupNames.value = []
  editingPlan.value = null
  planForm.value = { cycle: 1, upsellPaymentPlanIds: [], upsellButtonIds: [], orderBumpIds: [], videoCallIds: [], groupIds: [], status: PaymentPlanStatusEnum.ACTIVE, buttonStyle: undefined }
  isPlanDialogOpen.value = true
  isPaymentPlanComboboxOpen.value = false
  isButtonComboboxOpen.value = false
  if (orderBumps.value.length === 0) loadOrderBumps()
  if (groups.value.length === 0) loadGroups()
}

const closePlanDialog = () => {
  isPlanDialogOpen.value = false
}

const editPlan = async (plan: PaymentPlan) => {
  isPlanDialogOpen.value = true
  isPlanDialogLoading.value = true
  editingPlan.value = await getById(plan.id)
  
  if (orderBumps.value.length === 0) await loadOrderBumps()

  planForm.value = {
    name: plan.name,
    type:  plan.type,
    cycle: plan.cycle,
    amount: plan.amount,
    paymentApprovedMessage: plan.paymentApprovedMessage,
    buttonMessage:  plan.buttonMessage,
    upsellMessage: plan.upsellMessage,
    status: plan.status,
    upsellPaymentPlanIds: (editingPlan.value?.upsellPaymentPlans ?? []).map(p => p.id),
    upsellButtonIds: (editingPlan.value?.upsellButtons ?? []).map(b => b.id),
    orderBumpIds: (editingPlan.value?.orderBumps ?? []).map(b => b.id),
    videoCallIds: (editingPlan.value?.videoCalls ?? []).map(vc => vc.id),
    groupIds: (editingPlan.value?.groups ?? []).map(g => g.id),
    checkoutButtonLabel: plan.checkoutButtonLabel,
    productId: plan.productId,
    variantUUID: plan.variantUUID,
    buttonStyle: plan.buttonStyle
  }
  paymentPlanNames.value = editingPlan.value.upsellPaymentPlans?.map(p => p.name) ?? []
  buttonNames.value = editingPlan.value.upsellButtons?.map(b => b.name) ?? []
  orderBumpNames.value = editingPlan.value.orderBumps?.map(b => b.name) ?? []
  videoCallNames.value = editingPlan.value.videoCalls?.map(vc => vc.name) ?? []
  groupNames.value = editingPlan.value.groups?.map(g => g.name) ?? []
  
  upsell.value = !!editingPlan.value.upsellMessage
  isPlanDialogLoading.value = false
  isPlanDialogOpen.value = true
  isPaymentPlanComboboxOpen.value = false
  isButtonComboboxOpen.value = false

  if (videoCalls.value.length === 0) loadVideoCalls()
  if (groups.value.length === 0) loadGroups()
  if (plan.productId) {
    variants.value = await getAllVariantsByProductId(plan.productId) 
  }
}

const deletePlan = (plan: PaymentPlan) => {
  deletingPLan.value = plan.id
  isDeletePlanDialogOpen.value = true
}

const savePlan = async () => {
  isSaving.value = true
  let payload: any = { ...planForm.value }

  if (!payload.buttonMessage) {
    payload.buttonMessage = payload.name
  }

  if (payload.type === PaymentPlanTypeEnum.LIFETIME) {
    delete payload.cycle
  }

  if (!upsell.value) {
    payload.upsellMessage = null
    payload.upsellPaymentPlanIds = []
    payload.upsellButtonIds = []
  }

  if (!editingPlan.value) {
    create(payload as CreatePaymentPlanDTO, () => {
      isSaving.value = false
      toast({
        title: 'Plano de Pagamento criado com sucesso',
        class: 'bg-green-500 text-white',
        duration: 1500
      })
      getAll({ withGroupsAndPackages: true, withDownsells: true, withVideoCalls: true }).then((data) => paymentPlans.value = data)
      closePlanDialog()
    })
  } else {
    try {
      await update(editingPlan.value.id, payload)
      isSaving.value = false
        toast({
          title: 'Plano de Pagamento editado com sucesso',
          class: 'bg-green-500 text-white',
          duration: 1500
        })
        getAll({ withGroupsAndPackages: true, withDownsells: true, withVideoCalls: true }).then((data) => paymentPlans.value = data)
        closePlanDialog()
    } catch (error) {
      isSaving.value = false
    }
  }
}

const sortBy = (key: string) => {
  // Implement sorting logic
}

const cycleLabel = computed(() => {
    if (planForm.value.type === PaymentPlanTypeEnum.LIFETIME) return 'Vitalício';
    
    const cycleValue = planForm.value.cycle ?? 1;
    const units = {
        daily: cycleValue > 1 ? 'dias' : 'dia',
        weekly: cycleValue > 1 ? 'semanas' : 'semana',
        monthly: cycleValue > 1 ? 'meses' : 'mês',
        yearly: cycleValue > 1 ? 'anos' : 'ano'
    };
    
    return `${cycleValue} ${units[planForm.value.type as keyof typeof units] || ''}`;
})

const reloadAndGetAll = (params: GetAllPaymentPlansParams) => {
  paymentPlans.value = undefined
  getAll({ ...params, withDownsells: true, withVideoCalls: true }).then((data) => paymentPlans.value = data)
}

watch([() => typeFilter.value, () => perPage.value], () => {
  reloadAndGetAll({ type: typeFilter.value === 'all' ? undefined : typeFilter.value as PaymentPlanTypeEnum, search: searchQuery.value, perPage: perPage.value, withGroupsAndPackages: true, withDownsells: true, withVideoCalls: true  })
})

watch(() => isPlanDialogOpen.value, () => {
  if (!buttons.value) {
    getAllButtons()
      .then((data) => buttons.value = data)
    getAllProducts({ integrations: [IntegrationEnum.BOTEXPRESS], perPage: '100' })
      .then((data) => products.value = data)
  }
})

watch(() => planTab.value, () => {
  if (planTab.value === 'downsell' && editingPlan.value?.id) {
    const paymentPlan = paymentPlans.value?.data.find(plan => plan.id == editingPlan.value?.id)
    if ((paymentPlan?.groups?.length ?? 0) === 0 && (paymentPlan?.packages?.length ?? 0) === 0) {
      planTab.value = 'general'
      toast({
        title: 'Vincule pelo menos um grupo ou pack ao plano de pagamento antes de configurar o downsell.',
        class: 'bg-red-500 text-white',
        duration: 2000
      })
    }
  }
})

onMounted(() => {
  getAll({ withGroupsAndPackages: true, withDownsells: true, withVideoCalls: true, perPage: perPage.value }).then((data) => paymentPlans.value = data)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createVNode(PageTitle, null, {
            default: _withCtx(() => _cache[78] || (_cache[78] = [
              _createTextVNode(" Gerencie seus planos de pagamento ")
            ])),
            _: 1
          }),
          _createVNode(PageDescription, null, {
            default: _withCtx(() => _cache[79] || (_cache[79] = [
              _createTextVNode(" Defina valores, prazos e disponibilize ofertas exclusivas aos seus clientes. ")
            ])),
            _: 1
          })
        ]),
        _createVNode(RegisterButton, { onClick: openNewPlanDialog }, {
          default: _withCtx(() => _cache[80] || (_cache[80] = [
            _createTextVNode("Cadastrar plano")
          ])),
          _: 1
        })
      ]),
      _createVNode(TableContainer, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _cache[82] || (_cache[82] = _createElementVNode("h2", { class: "text-xl font-semibold text-white" }, "Planos de pagamento ativos", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(Input), {
                  modelValue: searchQuery.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                  placeholder: "Buscar planos...",
                  class: "w-[280px]",
                  onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (reloadAndGetAll({ type: typeFilter.value === 'all' ? undefined : typeFilter.value as PaymentPlanTypeEnum, search: searchQuery.value, withGroupsAndPackages: true })), ["enter"]))
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_unref(MagnifyingGlassIcon), { class: "h-4 w-4 text-zinc-400" })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createVNode(_unref(Select), {
                modelValue: typeFilter.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((typeFilter).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(SelectTrigger), { class: "w-[180px]" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(SelectValue), { placeholder: "Todos" })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(SelectContent), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(SelectItem), { value: "all" }, {
                        default: _withCtx(() => _cache[81] || (_cache[81] = [
                          _createTextVNode("Todos os tipos")
                        ])),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PaymentPlanTypeEnum), (type) => {
                        return (_openBlock(), _createBlock(_unref(SelectItem), { value: type }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(PaymentPlanTypeLabels)[type]), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 256))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createVNode(Table, { class: "hidden md:block" }, {
            default: _withCtx(() => [
              _createVNode(TableHeader, null, {
                default: _withCtx(() => [
                  _createVNode(TableRow, null, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tableHeaders, (header) => {
                        return _createVNode(TableHead, {
                          key: header.key,
                          class: _normalizeClass(header.class)
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                              _createTextVNode(_toDisplayString(header.label) + " ", 1),
                              (header.sortable)
                                ? (_openBlock(), _createBlock(_unref(ArrowsUpDownIcon), {
                                    key: 0,
                                    class: "h-4 w-4 cursor-pointer text-zinc-500 hover:text-white",
                                    onClick: ($event: any) => (sortBy(header.key))
                                  }, null, 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["class"])
                      }), 64))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(TableBody, null, {
                default: _withCtx(() => [
                  (paymentPlans.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (paymentPlans.value.data.length === 0)
                          ? (_openBlock(), _createBlock(TableFallback, {
                              key: 0,
                              colspan: tableHeaders.length,
                              icon: _unref(CreditCardIcon),
                              title: "Nenhum plano de pagamento encontrado",
                              description: `Clique em 'Cadastrar plano' para começar`
                            }, null, 8, ["colspan", "icon"]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentPlans.value.data, (plan) => {
                          return (_openBlock(), _createBlock(TableRow, {
                            key: plan.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(TableCell, { class: "whitespace-nowrap text-sm text-zinc-300" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: "p-2 rounded inline-flex py-2.5 px-8 text-center text-wrap",
                                    style: _normalizeStyle({ 
                    backgroundColor: plan.buttonStyle === 'primary' ? '#2B6B84' : 
                                    plan.buttonStyle === 'success' ? '#377531' : 
                                    plan.buttonStyle === 'danger' ? '#A44236' : '#2c3b4b4f' 
                  })
                                  }, _toDisplayString(plan.buttonMessage), 5)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(plan.amount.toLocaleString('pt-BR', { currency: 'brl', style: 'currency' })) + " ", 1),
                                  _cache[83] || (_cache[83] = _createElementVNode("br", null, null, -1)),
                                  _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(PaymentPlanTypeLabels)[plan.type]), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, { class: "whitespace-nowrap text-sm text-zinc-300" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("div", _hoisted_9, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plan.groups, (group) => {
                                        return (_openBlock(), _createBlock(_unref(Badge), { class: "text-wrap" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(group.name), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 256)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plan.packages, (pkg) => {
                                        return (_openBlock(), _createBlock(_unref(Badge), {
                                          class: "text-wrap",
                                          key: pkg.id
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(pkg.name), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plan.videoCalls, (vc) => {
                                        return (_openBlock(), _createBlock(_unref(Badge), {
                                          class: "text-wrap",
                                          key: vc.id
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(vc.name), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    (!plan.groups?.length && !plan.packages?.length && !plan.videoCalls?.length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                          _createVNode(_unref(Info), { class: "size-4 text-red-400" }),
                                          _cache[84] || (_cache[84] = _createTextVNode(" Vincule um grupo, pack ou vídeo chamada "))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_11, [
                                    (plan.downsells && plan.downsells.length > 0)
                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(plan.downsells, (ds) => {
                                          return (_openBlock(), _createBlock(_unref(Badge), {
                                            key: ds.id,
                                            variant: "outline",
                                            class: "text-[10px] text-white py-0 bg-yellow-700"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(ds.description), 1)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_12, "Nenhum"))
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createVNode(StatusBadge, {
                                    status: plan.status
                                  }, null, 8, ["status"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_13, [
                                    _createVNode(_unref(Button), {
                                      variant: "ghost",
                                      size: "icon",
                                      onClick: ($event: any) => (editPlan(plan))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(PencilIcon), { class: "h-4 w-4" })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_unref(Button), {
                                      variant: "ghost",
                                      size: "icon",
                                      class: "hover:text-red-400",
                                      onClick: ($event: any) => (deletePlan(plan))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(TrashIcon), { class: "h-4 w-4" })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ], 64))
                    : (_openBlock(), _createBlock(TableRowSkeleton, {
                        key: 1,
                        columns: tableHeaders.length
                      }, null, 8, ["columns"]))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (paymentPlans.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (paymentPlans.value.data.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(paymentPlans.value.data, (plan) => {
                      return (_openBlock(), _createBlock(MobileCard, {
                        key: plan.id
                      }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _cache[85] || (_cache[85] = _createElementVNode("span", { class: "text-[10px] uppercase font-bold text-zinc-500 tracking-wider" }, "Plano", -1)),
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("span", _hoisted_18, _toDisplayString(plan.name), 1)
                              ])
                            ])
                          ])
                        ]),
                        actions: _withCtx(() => [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("button", {
                                onClick: ($event: any) => (editPlan(plan)),
                                class: "text-zinc-400 hover:text-white p-1"
                              }, [
                                _createVNode(_unref(PencilIcon), { class: "size-5" })
                              ], 8, _hoisted_21),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (deletePlan(plan)),
                                class: "text-zinc-400 hover:text-red-400 p-1"
                              }, [
                                _createVNode(_unref(TrashIcon), { class: "size-5" })
                              ], 8, _hoisted_22)
                            ])
                          ])
                        ]),
                        content: _withCtx(() => [
                          _createElementVNode("div", _hoisted_23, [
                            _createVNode(MobileDataLabel, { label: "Valor" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(plan.amount.toLocaleString('pt-BR', { currency: 'brl', style: 'currency' })) + " ", 1),
                                _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(PaymentPlanTypeLabels)[plan.type]), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(MobileDataLabel, { label: "Botão" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", {
                                  class: "p-1 px-3 rounded inline-flex text-center text-xs truncate max-w-full",
                                  style: _normalizeStyle({ 
                          backgroundColor: plan.buttonStyle === 'primary' ? '#2B6B84' : 
                                          plan.buttonStyle === 'success' ? '#377531' : 
                                          plan.buttonStyle === 'danger' ? '#A44236' : '#2c3b4b4f' 
                        })
                                }, _toDisplayString(plan.buttonMessage), 5)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _createVNode(MobileDataLabel, { label: "Vínculos" }, {
                            default: _withCtx(() => [
                              (plan.groups?.length || plan.packages?.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plan.groups, (group) => {
                                      return (_openBlock(), _createBlock(_unref(Badge), {
                                        key: group.id,
                                        class: "text-[10px]"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(group.name), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plan.packages, (pkg) => {
                                      return (_openBlock(), _createBlock(_unref(Badge), {
                                        key: pkg.id,
                                        class: "text-[10px]"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(pkg.name), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plan.videoCalls, (vc) => {
                                      return (_openBlock(), _createBlock(_unref(Badge), {
                                        key: vc.id,
                                        class: "text-[10px]"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(vc.name), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true),
                              (!plan.groups?.length && !plan.packages?.length && !plan.videoCalls?.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                    _createVNode(_unref(Info), { class: "size-3 text-red-400" }),
                                    _cache[86] || (_cache[86] = _createTextVNode(" Vincule um grupo, pack ou vídeo chamada "))
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024),
                          (plan.downsells && plan.downsells.length > 0)
                            ? (_openBlock(), _createBlock(MobileDataLabel, {
                                key: 0,
                                label: "Downsells"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_27, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plan.downsells, (ds) => {
                                      return (_openBlock(), _createBlock(_unref(Badge), {
                                        key: ds.id,
                                        variant: "outline",
                                        class: "text-[10px] text-white py-0 bg-yellow-700"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(ds.description), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _cache[87] || (_cache[87] = _createElementVNode("span", { class: "text-[10px] uppercase font-bold text-zinc-500 tracking-wider mb-1" }, "Status", -1)),
                              _createVNode(StatusBadge, {
                                status: plan.status
                              }, null, 8, ["status"])
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createVNode(_unref(CreditCardIcon), { class: "size-8 mx-auto mb-3 text-zinc-700" }),
                      _cache[88] || (_cache[88] = _createTextVNode(" Nenhum plano de pagamento encontrado "))
                    ]))
              ]))
            : _createCommentVNode("", true),
          (paymentPlans.value?.pagination)
            ? (_openBlock(), _createBlock(Pagination, {
                key: 1,
                "onUpdate:page": _cache[3] || (_cache[3] = page => reloadAndGetAll({ page, withGroupsAndPackages: true })),
                data: paymentPlans.value?.pagination,
                "per-page": perPage.value,
                "onUpdate:perPage": _cache[4] || (_cache[4] = ($event: any) => ((perPage).value = $event))
              }, null, 8, ["data", "per-page"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createVNode(DeleteConfirmationDialog, {
      open: isDeletePlanDialogOpen.value,
      "onUpdate:open": _cache[5] || (_cache[5] = ($event: any) => ((isDeletePlanDialogOpen).value = $event)),
      loading: isDeletingPlan.value,
      onConfirm: _cache[6] || (_cache[6] = ($event: any) => {isDeletingPlan.value = true; _unref(destroy)(deletingPLan.value!, () => {
      _unref(toast)({
        title: 'Plano de Pagamento excluído com sucesso',
        class: 'bg-green-500 text-white',
        duration: 1500
      })
      isDeletingPlan.value = false
      isDeletePlanDialogOpen.value = false
      const index = paymentPlans.value?.data.findIndex(plan => plan.id == deletingPLan.value)
      if (index !== -1) paymentPlans.value?.data.splice(index!, 1)
    })})
    }, null, 8, ["open", "loading"]),
    _createVNode(_unref(Dialog), {
      open: isPlanDialogOpen.value,
      "onUpdate:open": _cache[76] || (_cache[76] = ($event: any) => ((isPlanDialogOpen).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DialogScrollContent), { class: "sm:max-w-3xl" }, {
          default: _withCtx(() => [
            _createVNode(_unref(DialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(editingPlan.value ? 'Editar plano' : 'Novo plano'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(DialogDescription), null, {
                  default: _withCtx(() => _cache[89] || (_cache[89] = [
                    _createTextVNode(" Configure as informações do plano de pagamento. ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            (!isPlanDialogLoading.value)
              ? (_openBlock(), _createBlock(_unref(Tabs), {
                  key: 0,
                  modelValue: planTab.value,
                  "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((planTab).value = $event)),
                  defaultValue: "general",
                  class: "w-full"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(TabsList), { class: "grid w-full grid-cols-2 lg:grid-cols-6 mb-4 bg-zinc-800 text-white" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(TabsTrigger), { value: "general" }, {
                          default: _withCtx(() => _cache[90] || (_cache[90] = [
                            _createTextVNode("Geral")
                          ])),
                          _: 1
                        }),
                        _createVNode(_unref(TabsTrigger), { value: "checkout" }, {
                          default: _withCtx(() => _cache[91] || (_cache[91] = [
                            _createElementVNode("div", { class: "flex items-center gap-1" }, [
                              _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "22",
                                height: "20",
                                viewBox: "0 0 25 24",
                                fill: "none"
                              }, [
                                _createElementVNode("path", {
                                  d: "M2.03027 8.505H22.0303",
                                  stroke: "#fff",
                                  "stroke-width": "1.5",
                                  "stroke-miterlimit": "10",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }),
                                _createElementVNode("path", {
                                  d: "M6.03027 16.505H8.03027",
                                  stroke: "#fff",
                                  "stroke-width": "1.5",
                                  "stroke-miterlimit": "10",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }),
                                _createElementVNode("path", {
                                  d: "M10.5303 16.505H14.5303",
                                  stroke: "#fff",
                                  "stroke-width": "1.5",
                                  "stroke-miterlimit": "10",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }),
                                _createElementVNode("path", {
                                  d: "M6.47027 3.505H17.5803C21.1403 3.505 22.0303 4.385 22.0303 7.895V16.105C22.0303 19.615 21.1403 20.495 17.5903 20.495H6.47027C2.92027 20.505 2.03027 19.625 2.03027 16.115V7.895C2.03027 4.385 2.92027 3.505 6.47027 3.505Z",
                                  stroke: "#fff",
                                  "stroke-width": "1.5",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                })
                              ]),
                              _createTextVNode(" Checkout ")
                            ], -1)
                          ])),
                          _: 1
                        }),
                        _createVNode(_unref(TabsTrigger), { value: "upsell" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_31, [
                              _createVNode(_unref(ArrowUp)),
                              _cache[92] || (_cache[92] = _createTextVNode(" Upsell "))
                            ])
                          ]),
                          _: 1
                        }),
                        (!editingPlan.value)
                          ? (_openBlock(), _createBlock(_unref(TooltipProvider), { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Tooltip), { "delay-duration": 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(TooltipTrigger), { "as-child": "" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_32, [
                                          _createVNode(_unref(TabsTrigger), {
                                            disabled: "",
                                            value: "downsell",
                                            class: "opacity-50 cursor-not-allowed"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_33, [
                                                _createVNode(_unref(ArrowDown)),
                                                _cache[93] || (_cache[93] = _createTextVNode(" Downsell "))
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(TooltipContent), { side: "top" }, {
                                      default: _withCtx(() => _cache[94] || (_cache[94] = [
                                        _createTextVNode(" Para configurar o downsell, primeiro crie o seu plano. ")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_unref(TabsTrigger), {
                              key: 1,
                              value: "downsell"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_34, [
                                  _createVNode(_unref(ArrowDown)),
                                  _cache[95] || (_cache[95] = _createTextVNode(" Downsell "))
                                ])
                              ]),
                              _: 1
                            })),
                        _createVNode(_unref(TabsTrigger), { value: "order_bumps" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_35, [
                              _createVNode(_unref(ArrowUp)),
                              _cache[96] || (_cache[96] = _createTextVNode(" Order Bumps "))
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(TabsTrigger), { value: "video_calls" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_36, [
                              _createVNode(_unref(Phone), { class: "size-4" }),
                              _cache[97] || (_cache[97] = _createTextVNode(" V. Chamada "))
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(TabsContent), { value: "general" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _createVNode(_unref(Label), null, {
                              default: _withCtx(() => _cache[98] || (_cache[98] = [
                                _createTextVNode("Nome do plano "),
                                _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                              ])),
                              _: 1
                            }),
                            _createVNode(_unref(Input), {
                              modelValue: planForm.value.name,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((planForm.value.name) = $event)),
                              placeholder: "Ex: Plano Premium"
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _createVNode(_unref(Label), null, {
                              default: _withCtx(() => _cache[99] || (_cache[99] = [
                                _createTextVNode("Valor "),
                                _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                              ])),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_40, [
                              _createVNode(_unref(Input), {
                                modelValue: planForm.value.amount,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((planForm.value.amount) = $event)),
                                type: "number",
                                placeholder: "0,00",
                                min: "1",
                                step: "0.01"
                              }, null, 8, ["modelValue"]),
                              _createVNode(_unref(DollarSign), { class: "absolute right-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-[#9CA3AF]" })
                            ])
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass([{ 'col-span-full': planForm.value.type === _unref(PaymentPlanTypeEnum).LIFETIME, 'sm:col-span-1': planForm.value.type !== _unref(PaymentPlanTypeEnum).LIFETIME }, "grid gap-2 col-span-full"])
                          }, [
                            _createVNode(_unref(Label), null, {
                              default: _withCtx(() => _cache[100] || (_cache[100] = [
                                _createTextVNode("Tipo de cobrança "),
                                _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                              ])),
                              _: 1
                            }),
                            _createVNode(_unref(Select), {
                              modelValue: planForm.value.type,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((planForm.value.type) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(SelectTrigger), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(SelectValue), { placeholder: "Selecione o tipo" })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(SelectContent), null, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PaymentPlanTypeEnum), (type) => {
                                      return (_openBlock(), _createBlock(_unref(SelectItem), { value: type }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(PaymentPlanTypeLabels)[type]), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 256))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ], 2),
                          (planForm.value.type !== _unref(PaymentPlanTypeEnum).LIFETIME)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                _createElementVNode("div", _hoisted_42, [
                                  _createVNode(_unref(Label), null, {
                                    default: _withCtx(() => _cache[101] || (_cache[101] = [
                                      _createTextVNode("Cobrança a cada "),
                                      _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                                    ])),
                                    _: 1
                                  }),
                                  (planForm.value.type)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(cycleLabel.value), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode(_unref(Input), {
                                  modelValue: planForm.value.cycle,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((planForm.value.cycle) = $event)),
                                  type: "number",
                                  placeholder: "Ex: 1",
                                  min: "1",
                                  step: "0.01"
                                }, null, 8, ["modelValue"])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, [
                              _createVNode(_unref(Label), null, {
                                default: _withCtx(() => _cache[102] || (_cache[102] = [
                                  _createTextVNode("Status "),
                                  _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                                ])),
                                _: 1
                              }),
                              _createVNode(_unref(TooltipProvider), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Tooltip), { "delay-duration": 100 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(TooltipTrigger), { "as-child": "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CircleHelp), { class: "size-5 text-primary" })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(TooltipContent), {
                                        side: "top",
                                        "side-offset": 5
                                      }, {
                                        default: _withCtx(() => _cache[103] || (_cache[103] = [
                                          _createTextVNode(" Status oculto: Este plano não será exibido "),
                                          _createElementVNode("br", null, null, -1),
                                          _createTextVNode(" quando o usuário iniciar o bot. ")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _createVNode(_unref(Select), {
                              modelValue: planForm.value.status,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((planForm.value.status) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(SelectTrigger), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(SelectValue), { placeholder: "Selecione o status" })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(SelectContent), null, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PaymentPlanStatusEnum), (status) => {
                                      return (_openBlock(), _createBlock(_unref(SelectItem), { value: status }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(PaymentPlanStatusLabels)[status]), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 256))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _createVNode(_unref(Label), null, {
                              default: _withCtx(() => _cache[104] || (_cache[104] = [
                                _createTextVNode("Mensagem do botão")
                              ])),
                              _: 1
                            }),
                            _createVNode(_unref(Input), {
                              modelValue: planForm.value.buttonMessage,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((planForm.value.buttonMessage) = $event)),
                              placeholder: "Ex: Plano Premium"
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_47, [
                            _createVNode(_unref(Label), null, {
                              default: _withCtx(() => _cache[105] || (_cache[105] = [
                                _createTextVNode("Cor do botão")
                              ])),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_48, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[13] || (_cache[13] = ($event: any) => (planForm.value.buttonStyle = undefined)),
                                class: _normalizeClass(["size-8 rounded-full border-2 transition-all hover:scale-110", [planForm.value.buttonStyle === undefined || planForm.value.buttonStyle === '' ? 'border-white scale-110' : 'border-transparent']]),
                                style: {"background-color":"#2c3b4b4f"},
                                title: "Padrão (Cinza)"
                              }, null, 2),
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[14] || (_cache[14] = ($event: any) => (planForm.value.buttonStyle = 'primary')),
                                class: _normalizeClass(["size-8 rounded-full border-2 transition-all hover:scale-110", [planForm.value.buttonStyle === 'primary' ? 'border-white scale-110' : 'border-transparent']]),
                                style: {"background-color":"#2B6B84"},
                                title: "Azul"
                              }, null, 2),
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[15] || (_cache[15] = ($event: any) => (planForm.value.buttonStyle = 'success')),
                                class: _normalizeClass(["size-8 rounded-full border-2 transition-all hover:scale-110", [planForm.value.buttonStyle === 'success' ? 'border-white scale-110' : 'border-transparent']]),
                                style: {"background-color":"#377531"},
                                title: "Verde"
                              }, null, 2),
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[16] || (_cache[16] = ($event: any) => (planForm.value.buttonStyle = 'danger')),
                                class: _normalizeClass(["size-8 rounded-full border-2 transition-all hover:scale-110", [planForm.value.buttonStyle === 'danger' ? 'border-white scale-110' : 'border-transparent']]),
                                style: {"background-color":"#A44236"},
                                title: "Vermelho"
                              }, null, 2)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_49, [
                            _createVNode(_unref(Label), null, {
                              default: _withCtx(() => _cache[106] || (_cache[106] = [
                                _createTextVNode("Mensagem de pagamento aprovado")
                              ])),
                              _: 1
                            }),
                            _createVNode(_unref(Textarea), {
                              modelValue: planForm.value.paymentApprovedMessage,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((planForm.value.paymentApprovedMessage) = $event)),
                              placeholder: "Ex: ✅ Venda confirmada com sucesso!"
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_50, [
                            _createVNode(_unref(Label), null, {
                              default: _withCtx(() => _cache[107] || (_cache[107] = [
                                _createTextVNode("Grupos")
                              ])),
                              _: 1
                            }),
                            (filteredGroups.value)
                              ? (_openBlock(), _createBlock(_unref(TagsInput), {
                                  key: 0,
                                  class: "px-0 gap-0 w-full",
                                  "model-value": groupNames.value
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_51, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupNames.value, (item) => {
                                        return (_openBlock(), _createBlock(_unref(TagsInputItem), {
                                          key: item,
                                          value: item
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(TagsInputItemText)),
                                            _createVNode(_unref(TagsInputItemDelete), {
                                              onClick: () => {
                      const group = groups.value?.find(p => p.name == item)
                      if (group) {
                        planForm.value.groupIds = planForm.value.groupIds?.filter(id => String(id) !== String(group.id))
                        groupNames.value = groupNames.value.filter(i => i !== item)
                      }
                    }
                                            }, null, 8, ["onClick"])
                                          ]),
                                          _: 2
                                        }, 1032, ["value"]))
                                      }), 128))
                                    ]),
                                    _createVNode(_unref(ComboboxRoot), {
                                      modelValue: groupNames.value,
                                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((groupNames).value = $event)),
                                      open: isGroupComboboxOpen.value,
                                      "onUpdate:open": _cache[21] || (_cache[21] = ($event: any) => ((isGroupComboboxOpen).value = $event)),
                                      "search-term": searchGroup.value,
                                      "onUpdate:searchTerm": _cache[22] || (_cache[22] = ($event: any) => ((searchGroup).value = $event)),
                                      class: "w-full"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(ComboboxAnchor), { "as-child": "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(ComboboxInput), {
                                              placeholder: "Selecione os grupos...",
                                              "as-child": ""
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(TagsInputInput), {
                                                  onFocus: _cache[18] || (_cache[18] = ($event: any) => (isGroupComboboxOpen.value = true)),
                                                  class: _normalizeClass(["w-full px-3", groupNames.value.length > 0 ? 'mt-2' : '']),
                                                  onKeydown: _cache[19] || (_cache[19] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                                                }, null, 8, ["class"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_unref(ComboboxPortal), null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(ComboboxContent), null, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(CommandList), {
                                                  position: "popper",
                                                  class: "w-[--radix-popper-anchor-width] rounded-md mt-2 border bg-popover text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(CommandEmpty), null, {
                                                      default: _withCtx(() => _cache[108] || (_cache[108] = [
                                                        _createTextVNode("Nenhum grupo encontrado")
                                                      ])),
                                                      _: 1
                                                    }),
                                                    _createVNode(_unref(CommandGroup), null, {
                                                      default: _withCtx(() => [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredGroups.value, (group) => {
                                                          return (_openBlock(), _createBlock(_unref(CommandItem), {
                                                            key: group.id,
                                                            value: String(group.name),
                                                            onSelect: _withModifiers((ev) => {
                              if (typeof ev.detail.value === 'string') {
                                searchGroup.value = ''
                                const group = filteredGroups.value?.find(p => p.name == ev.detail.value)
                                planForm.value.groupIds?.push(Number(group!.id))
                                groupNames.value.push(group!.name)
                              }

                              if (filteredGroups.value?.length === 0) {
                                isGroupComboboxOpen.value = false
                              }
                            }, ["prevent"])
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(group.name), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["value", "onSelect"]))
                                                        }), 128))
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "open", "search-term"])
                                  ]),
                                  _: 1
                                }, 8, ["model-value"]))
                              : _createCommentVNode("", true),
                            _cache[109] || (_cache[109] = _createElementVNode("p", { class: "text-xs text-gray-400" }, "Você pode anexar um ou mais grupos a este plano", -1))
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(TabsContent), { value: "checkout" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_53, [
                              _createVNode(_unref(Label), null, {
                                default: _withCtx(() => _cache[110] || (_cache[110] = [
                                  _createTextVNode("Produto "),
                                  _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                                ])),
                                _: 1
                              }),
                              _createVNode(_unref(Select), {
                                "model-value": String(planForm.value.productId),
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = (value) => changeProductId(Number(value)))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(SelectTrigger), {
                                    id: "productId",
                                    "aria-label": "Selecionar o produto"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(SelectValue), { placeholder: "Selecionar" })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(SelectContent), null, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value?.data, (product) => {
                                        return (_openBlock(), _createBlock(_unref(SelectItem), {
                                          key: product.id,
                                          value: String(product.id)
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(product.title), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["value"]))
                                      }), 128)),
                                      (!products.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                            _createVNode(_unref(Loader2), { class: "w-5 h-5 animate-spin" })
                                          ]))
                                        : _createCommentVNode("", true),
                                      (products.value && products.value.data.length === 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                            _createVNode(_unref(Button), {
                                              onClick: createProduct,
                                              class: "text-sm text-center mx-auto"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(PlusIcon), { class: "h-5 w-5 hidden 2xl:block" }),
                                                _cache[111] || (_cache[111] = _createTextVNode(" Cadastrar produto "))
                                              ]),
                                              _: 1
                                            })
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["model-value"])
                            ]),
                            (!planForm.value.productId)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_56, [
                                  _createVNode(_unref(Info), { class: "size-4 text-yellow-400" }),
                                  _cache[112] || (_cache[112] = _createElementVNode("p", null, "Caso seu produto não esteja visível, é necessário ativar a integração Bot Express na HooPay para ele ser selecionável.", -1))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          (planForm.value.productId)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                _createVNode(_unref(Label), null, {
                                  default: _withCtx(() => _cache[113] || (_cache[113] = [
                                    _createTextVNode("Variante "),
                                    _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_unref(Select), {
                                  modelValue: planForm.value.variantUUID,
                                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((planForm.value.variantUUID) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(SelectTrigger), {
                                      id: "variantId",
                                      "aria-label": "Selecionar variante"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(SelectValue), { placeholder: "Selecionar" })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(SelectContent), null, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variants.value, (variant) => {
                                          return (_openBlock(), _createBlock(_unref(SelectItem), {
                                            key: variant.id,
                                            value: String(variant.uuid)
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(variant.title), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["value"]))
                                        }), 128)),
                                        (isVariantsLoading.value)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                              _createVNode(_unref(Loader2), { class: "w-5 h-5 animate-spin" })
                                            ]))
                                          : _createCommentVNode("", true),
                                        (!isVariantsLoading.value && variants.value && variants.value.length === 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                              _createVNode(_unref(Button), {
                                                onClick: createVariant,
                                                class: "text-sm text-center mx-auto"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(PlusIcon), { class: "h-5 w-5 hidden 2xl:block" }),
                                                  _cache[114] || (_cache[114] = _createTextVNode(" Cadastrar variante "))
                                                ]),
                                                _: 1
                                              })
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_60, [
                              _createVNode(_unref(Label), null, {
                                default: _withCtx(() => _cache[115] || (_cache[115] = [
                                  _createTextVNode("Mensagem do botão "),
                                  _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                                ])),
                                _: 1
                              }),
                              _createVNode(_unref(Input), {
                                modelValue: planForm.value.checkoutButtonLabel,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((planForm.value.checkoutButtonLabel) = $event)),
                                placeholder: "Ex: Cartão de Crédito ou Checkout"
                              }, null, 8, ["modelValue"])
                            ]),
                            (!planForm.value.variantUUID)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_61, [
                                  _createVNode(_unref(Info), { class: "size-4 text-yellow-400" }),
                                  _cache[116] || (_cache[116] = _createTextVNode(" O método de pagamento com checkout só ficará disponível ao selecionar um variante. "))
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_62, [
                              _createVNode(_unref(HelpCircle), { class: "h-4 w-4 text-emerald-400 flex-shrink-0" }),
                              _createElementVNode("p", {
                                class: "text-xs text-zinc-300 mb-0 cursor-pointer",
                                onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.$router.push({ name: 'help', query: { tutorialId: 3, step: 4 } })))
                              }, _cache[117] || (_cache[117] = [
                                _createTextVNode("Não entendeu? "),
                                _createElementVNode("span", { class: "text-emerald-400" }, "Clique aqui.", -1)
                              ]))
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(TabsContent), { value: "upsell" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("div", _hoisted_64, [
                            _createVNode(_unref(Label), null, {
                              default: _withCtx(() => _cache[118] || (_cache[118] = [
                                _createTextVNode("Mensagem de upsell "),
                                _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                              ])),
                              _: 1
                            }),
                            _createVNode(RichTextarea, {
                              modelValue: planForm.value.upsellMessage,
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((planForm.value.upsellMessage) = $event)),
                              placeholder: "Ex: Você pode gostar também...",
                              variables: [
                  { label: 'Nome', value: '{{nome}}' }
                ]
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_65, [
                            _createVNode(_unref(Label), null, {
                              default: _withCtx(() => _cache[119] || (_cache[119] = [
                                _createTextVNode("Planos")
                              ])),
                              _: 1
                            }),
                            (filteredPaymentPlans.value)
                              ? (_openBlock(), _createBlock(_unref(TagsInput), {
                                  key: 0,
                                  class: "px-0 gap-0 w-full",
                                  "model-value": paymentPlanNames.value
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_66, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentPlanNames.value, (name, index) => {
                                        return (_openBlock(), _createBlock(_unref(TagsInputItem), {
                                          key: index,
                                          value: name
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(TagsInputItemText)),
                                            _createVNode(_unref(TagsInputItemDelete), {
                                              onClick: ($event: any) => {planForm.value.upsellPaymentPlanIds?.splice(index, 1); paymentPlanNames.value.splice(index, 1)}
                                            }, null, 8, ["onClick"])
                                          ]),
                                          _: 2
                                        }, 1032, ["value"]))
                                      }), 128))
                                    ]),
                                    _createVNode(_unref(ComboboxRoot), {
                                      modelValue: paymentPlanNames.value,
                                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((paymentPlanNames).value = $event)),
                                      open: isPaymentPlanComboboxOpen.value,
                                      "onUpdate:open": _cache[31] || (_cache[31] = ($event: any) => ((isPaymentPlanComboboxOpen).value = $event)),
                                      "search-term": searchPaymentPlan.value,
                                      "onUpdate:searchTerm": _cache[32] || (_cache[32] = ($event: any) => ((searchPaymentPlan).value = $event)),
                                      class: "w-full"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(ComboboxAnchor), { "as-child": "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(ComboboxInput), {
                                              placeholder: "Plano premium...",
                                              "as-child": ""
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(TagsInputInput), {
                                                  onFocus: _cache[28] || (_cache[28] = ($event: any) => (isPaymentPlanComboboxOpen.value = true)),
                                                  class: _normalizeClass(["w-full px-3", (planForm.value.upsellPaymentPlanIds?.length ?? 0) > 0 ? 'mt-2' : '']),
                                                  onKeydown: _cache[29] || (_cache[29] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                                                }, null, 8, ["class"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_unref(ComboboxPortal), null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(ComboboxContent), null, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(CommandList), {
                                                  position: "popper",
                                                  class: "w-[--radix-popper-anchor-width] rounded-md mt-2 border bg-popover text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(CommandEmpty), null, {
                                                      default: _withCtx(() => _cache[120] || (_cache[120] = [
                                                        _createTextVNode("Nenhum plano encontrado")
                                                      ])),
                                                      _: 1
                                                    }),
                                                    _createVNode(_unref(CommandGroup), null, {
                                                      default: _withCtx(() => [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredPaymentPlans.value, (paymentPlan) => {
                                                          return (_openBlock(), _createBlock(_unref(CommandItem), {
                                                            key: paymentPlan.id,
                                                            value: String(paymentPlan.name),
                                                            onSelect: _withModifiers((ev) => {
                              if (typeof ev.detail.value === 'string') {
                                searchPaymentPlan.value = ''
                                 const paymentPlan = filteredPaymentPlans.value?.find(plan => plan.name == ev.detail.value)
                                planForm.value.upsellPaymentPlanIds?.push(paymentPlan!.id)
                                paymentPlanNames.value.push(paymentPlan!.name)
                                upsell.value = true
                              }
            
                              if (filteredPaymentPlans.value?.length === 0) {
                                isPaymentPlanComboboxOpen.value = false
                              }
                            }, ["prevent"])
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(paymentPlan.name), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["value", "onSelect"]))
                                                        }), 128))
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "open", "search-term"])
                                  ]),
                                  _: 1
                                }, 8, ["model-value"]))
                              : _createCommentVNode("", true),
                            _cache[121] || (_cache[121] = _createElementVNode("p", { class: "text-xs text-gray-400" }, "Você pode selecionar mais de 1 plano", -1))
                          ]),
                          _createElementVNode("div", _hoisted_67, [
                            _createVNode(_unref(Label), null, {
                              default: _withCtx(() => _cache[122] || (_cache[122] = [
                                _createTextVNode("Links de redirecionamento")
                              ])),
                              _: 1
                            }),
                            (filteredButtons.value)
                              ? (_openBlock(), _createBlock(_unref(TagsInput), {
                                  key: 0,
                                  class: "px-0 gap-0 w-full",
                                  "model-value": buttonNames.value
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_68, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buttonNames.value, (name, index) => {
                                        return (_openBlock(), _createBlock(_unref(TagsInputItem), {
                                          key: index,
                                          value: name
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(TagsInputItemText)),
                                            _createVNode(_unref(TagsInputItemDelete), {
                                              onClick: ($event: any) => {planForm.value.upsellButtonIds?.splice(index, 1); buttonNames.value.splice(index, 1)}
                                            }, null, 8, ["onClick"])
                                          ]),
                                          _: 2
                                        }, 1032, ["value"]))
                                      }), 128))
                                    ]),
                                    _createVNode(_unref(ComboboxRoot), {
                                      modelValue: buttonNames.value,
                                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((buttonNames).value = $event)),
                                      open: isButtonComboboxOpen.value,
                                      "onUpdate:open": _cache[36] || (_cache[36] = ($event: any) => ((isButtonComboboxOpen).value = $event)),
                                      "search-term": searchButton.value,
                                      "onUpdate:searchTerm": _cache[37] || (_cache[37] = ($event: any) => ((searchButton).value = $event)),
                                      class: "w-full"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(ComboboxAnchor), { "as-child": "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(ComboboxInput), {
                                              placeholder: "Link para landing page...",
                                              "as-child": ""
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(TagsInputInput), {
                                                  onFocus: _cache[33] || (_cache[33] = ($event: any) => (isButtonComboboxOpen.value = true)),
                                                  class: _normalizeClass(["w-full px-3", (planForm.value.upsellButtonIds?.length ?? 0) > 0 ? 'mt-2' : '']),
                                                  onKeydown: _cache[34] || (_cache[34] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                                                }, null, 8, ["class"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_unref(ComboboxPortal), null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(ComboboxContent), null, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(CommandList), {
                                                  position: "popper",
                                                  class: "w-[--radix-popper-anchor-width] rounded-md mt-2 border bg-popover text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(CommandEmpty), null, {
                                                      default: _withCtx(() => _cache[123] || (_cache[123] = [
                                                        _createTextVNode("Nenhum link encontrado")
                                                      ])),
                                                      _: 1
                                                    }),
                                                    _createVNode(_unref(CommandGroup), null, {
                                                      default: _withCtx(() => [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredButtons.value, (button) => {
                                                          return (_openBlock(), _createBlock(_unref(CommandItem), {
                                                            key: button.id,
                                                            value: String(button.name),
                                                            onSelect: _withModifiers((ev) => {
                              if (typeof ev.detail.value === 'string') {
                                searchButton.value = ''
                                 const button = filteredButtons.value?.find(plan => plan.name == ev.detail.value)
                                planForm.value.upsellButtonIds?.push(button!.id)
                                buttonNames.value.push(button!.name)
                                upsell.value = true
                              }
            
                              if (filteredButtons.value?.length === 0) {
                                isButtonComboboxOpen.value = false
                              }
                            }, ["prevent"])
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(button.name), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["value", "onSelect"]))
                                                        }), 128))
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "open", "search-term"])
                                  ]),
                                  _: 1
                                }, 8, ["model-value"]))
                              : _createCommentVNode("", true),
                            _cache[124] || (_cache[124] = _createElementVNode("p", { class: "text-xs text-gray-400" }, "Você pode selecionar mais de 1 link", -1))
                          ]),
                          _createElementVNode("div", _hoisted_69, [
                            _createElementVNode("div", _hoisted_70, [
                              _createVNode(_unref(Switch), {
                                checked: upsell.value,
                                "onUpdate:checked": _cache[38] || (_cache[38] = ($event: any) => ((upsell).value = $event))
                              }, null, 8, ["checked"]),
                              _createVNode(_unref(Label), null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(upsell.value ? 'Ativo' : 'Inativo'), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(TabsContent), { value: "order_bumps" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_71, [
                          _createVNode(_unref(Label), null, {
                            default: _withCtx(() => _cache[125] || (_cache[125] = [
                              _createTextVNode("Order Bumps Associados")
                            ])),
                            _: 1
                          }),
                          (filteredOrderBumps.value)
                            ? (_openBlock(), _createBlock(_unref(TagsInput), {
                                key: 0,
                                class: "px-0 gap-0 w-full",
                                "model-value": orderBumpNames.value
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_72, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderBumpNames.value, (name, index) => {
                                      return (_openBlock(), _createBlock(_unref(TagsInputItem), {
                                        key: index,
                                        value: name
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(TagsInputItemText)),
                                          _createVNode(_unref(TagsInputItemDelete), {
                                            onClick: ($event: any) => {planForm.value.orderBumpIds?.splice(index, 1); orderBumpNames.value.splice(index, 1)}
                                          }, null, 8, ["onClick"])
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 128))
                                  ]),
                                  _createVNode(_unref(ComboboxRoot), {
                                    modelValue: orderBumpNames.value,
                                    "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((orderBumpNames).value = $event)),
                                    open: isOrderBumpComboboxOpen.value,
                                    "onUpdate:open": _cache[42] || (_cache[42] = ($event: any) => ((isOrderBumpComboboxOpen).value = $event)),
                                    "search-term": searchOrderBump.value,
                                    "onUpdate:searchTerm": _cache[43] || (_cache[43] = ($event: any) => ((searchOrderBump).value = $event)),
                                    class: "w-full"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ComboboxAnchor), { "as-child": "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(ComboboxInput), {
                                            placeholder: "Selecionar order bump...",
                                            "as-child": ""
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(TagsInputInput), {
                                                onFocus: _cache[39] || (_cache[39] = ($event: any) => (isOrderBumpComboboxOpen.value = true)),
                                                class: _normalizeClass(["w-full px-3", (planForm.value.orderBumpIds?.length ?? 0) > 0 ? 'mt-2' : '']),
                                                onKeydown: _cache[40] || (_cache[40] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                                              }, null, 8, ["class"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(ComboboxPortal), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(ComboboxContent), null, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(CommandList), {
                                                position: "popper",
                                                class: "w-[--radix-popper-anchor-width] rounded-md mt-2 border bg-popover text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(CommandEmpty), null, {
                                                    default: _withCtx(() => _cache[126] || (_cache[126] = [
                                                      _createTextVNode("Nenhum order bump encontrado")
                                                    ])),
                                                    _: 1
                                                  }),
                                                  _createVNode(_unref(CommandGroup), null, {
                                                    default: _withCtx(() => [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOrderBumps.value, (bump) => {
                                                        return (_openBlock(), _createBlock(_unref(CommandItem), {
                                                          key: bump.id,
                                                          value: String(bump.name),
                                                          onSelect: _withModifiers((ev) => {
                              if (typeof ev.detail.value === 'string') {
                                searchOrderBump.value = ''
                                const bump = filteredOrderBumps.value?.find(b => b.name == ev.detail.value)
                                planForm.value.orderBumpIds?.push(bump!.id)
                                orderBumpNames.value.push(bump!.name)
                              }
            
                              if (filteredOrderBumps.value?.length === 0) {
                                isOrderBumpComboboxOpen.value = false
                              }
                            }, ["prevent"])
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(bump.name), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["value", "onSelect"]))
                                                      }), 128))
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "open", "search-term"])
                                ]),
                                _: 1
                              }, 8, ["model-value"]))
                            : _createCommentVNode("", true),
                          _cache[127] || (_cache[127] = _createElementVNode("p", { class: "text-xs text-gray-400" }, "Ofertas exibidas ao selecionar este plano.", -1))
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(TabsContent), { value: "video_calls" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_73, [
                          _createVNode(_unref(Label), null, {
                            default: _withCtx(() => _cache[128] || (_cache[128] = [
                              _createTextVNode("Vídeo Chamadas Associadas")
                            ])),
                            _: 1
                          }),
                          (filteredVideoCalls.value)
                            ? (_openBlock(), _createBlock(_unref(TagsInput), {
                                key: 0,
                                class: "px-0 gap-0 w-full",
                                "model-value": videoCallNames.value
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_74, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(videoCallNames.value, (name, index) => {
                                      return (_openBlock(), _createBlock(_unref(TagsInputItem), {
                                        key: index,
                                        value: name
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(TagsInputItemText)),
                                          _createVNode(_unref(TagsInputItemDelete), {
                                            onClick: ($event: any) => {planForm.value.videoCallIds?.splice(index, 1); videoCallNames.value.splice(index, 1)}
                                          }, null, 8, ["onClick"])
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 128))
                                  ]),
                                  _createVNode(_unref(ComboboxRoot), {
                                    modelValue: videoCallNames.value,
                                    "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((videoCallNames).value = $event)),
                                    open: isVideoCallComboboxOpen.value,
                                    "onUpdate:open": _cache[47] || (_cache[47] = ($event: any) => ((isVideoCallComboboxOpen).value = $event)),
                                    "search-term": searchVideoCall.value,
                                    "onUpdate:searchTerm": _cache[48] || (_cache[48] = ($event: any) => ((searchVideoCall).value = $event)),
                                    class: "w-full"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ComboboxAnchor), { "as-child": "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(ComboboxInput), {
                                            placeholder: "Selecionar vídeo chamada...",
                                            "as-child": ""
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(TagsInputInput), {
                                                onFocus: _cache[44] || (_cache[44] = ($event: any) => (isVideoCallComboboxOpen.value = true)),
                                                class: _normalizeClass(["w-full px-3", (planForm.value.videoCallIds?.length ?? 0) > 0 ? 'mt-2' : '']),
                                                onKeydown: _cache[45] || (_cache[45] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                                              }, null, 8, ["class"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(ComboboxPortal), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(ComboboxContent), null, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(CommandList), {
                                                position: "popper",
                                                class: "w-[--radix-popper-anchor-width] rounded-md mt-2 border bg-popover text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(CommandEmpty), null, {
                                                    default: _withCtx(() => _cache[129] || (_cache[129] = [
                                                      _createTextVNode("Nenhuma vídeo chamada encontrada")
                                                    ])),
                                                    _: 1
                                                  }),
                                                  _createVNode(_unref(CommandGroup), null, {
                                                    default: _withCtx(() => [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredVideoCalls.value, (vc) => {
                                                        return (_openBlock(), _createBlock(_unref(CommandItem), {
                                                          key: vc.id,
                                                          value: String(vc.name),
                                                          onSelect: _withModifiers((ev) => {
                              if (typeof ev.detail.value === 'string') {
                                searchVideoCall.value = ''
                                const vc = filteredVideoCalls.value?.find(v => v.name == ev.detail.value)
                                planForm.value.videoCallIds?.push(vc!.id)
                                videoCallNames.value.push(vc!.name)
                              }
            
                              if (filteredVideoCalls.value?.length === 0) {
                                isVideoCallComboboxOpen.value = false
                              }
                            }, ["prevent"])
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(vc.name), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["value", "onSelect"]))
                                                      }), 128))
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "open", "search-term"])
                                ]),
                                _: 1
                              }, 8, ["model-value"]))
                            : _createCommentVNode("", true),
                          _cache[130] || (_cache[130] = _createElementVNode("p", { class: "text-xs text-gray-400" }, "Vídeos exibidos após o pagamento deste plano.", -1))
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(TabsContent), { value: "downsell" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_75, [
                          _createElementVNode("div", _hoisted_76, [
                            _cache[132] || (_cache[132] = _createElementVNode("div", null, [
                              _createElementVNode("h3", { class: "text-sm font-semibold text-white" }, "Mensagens de Recuperação"),
                              _createElementVNode("p", { class: "text-xs text-zinc-400 mt-1" }, "Configure disparos automáticos após abandono de checkout.")
                            ], -1)),
                            (!isAddingDownsell.value)
                              ? (_openBlock(), _createBlock(_unref(Button), {
                                  key: 0,
                                  size: "sm",
                                  class: "gap-2 bg-primary/10 hover:bg-primary/20 text-primary border border-primary/30 hover:border-primary/50 transition-all",
                                  onClick: openNewDownsellForm
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(PlusIcon), { class: "size-4" }),
                                    _cache[131] || (_cache[131] = _createTextVNode(" Novo Downsell "))
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          (isAddingDownsell.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                _createElementVNode("div", _hoisted_78, [
                                  _createElementVNode("div", _hoisted_79, [
                                    _createElementVNode("div", _hoisted_80, [
                                      _createVNode(_unref(Label), null, {
                                        default: _withCtx(() => _cache[133] || (_cache[133] = [
                                          _createTextVNode("Descrição "),
                                          _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                                        ])),
                                        _: 1
                                      }),
                                      _createVNode(_unref(Input), {
                                        modelValue: downsellForm.value.description,
                                        "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((downsellForm.value.description) = $event)),
                                        placeholder: "Ex: Downsell 1 hora"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_81, [
                                      _createVNode(AnyFileUpload, {
                                        preview: downsellStartMediaPreview.value!,
                                        "onUpdate:preview": _cache[50] || (_cache[50] = ($event: any) => ((downsellStartMediaPreview.value!) = $event)),
                                        modelValue: downsellStartMedia.value,
                                        "onUpdate:modelValue": [
                                          _cache[51] || (_cache[51] = ($event: any) => ((downsellStartMedia).value = $event)),
                                          _cache[53] || (_cache[53] = (f) => downsellStartMedia.value = f)
                                        ],
                                        "has-spoiler": downsellForm.value.hasSpoiler,
                                        "onUpdate:hasSpoiler": _cache[52] || (_cache[52] = ($event: any) => ((downsellForm.value.hasSpoiler) = $event))
                                      }, null, 8, ["preview", "modelValue", "has-spoiler"])
                                    ]),
                                    _createElementVNode("div", _hoisted_82, [
                                      _createVNode(_unref(Label), null, {
                                        default: _withCtx(() => _cache[134] || (_cache[134] = [
                                          _createTextVNode("Mensagem")
                                        ])),
                                        _: 1
                                      }),
                                      _createVNode(RichTextarea, {
                                        modelValue: downsellForm.value.message,
                                        "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((downsellForm.value.message) = $event)),
                                        placeholder: "Olá {{nome}}, vimos que você quase finalizou...",
                                        rows: 4,
                                        variables: [
                        { label: 'Nome', value: '{{nome}}' }
                      ]
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_83, [
                                    _createElementVNode("div", _hoisted_84, [
                                      _createVNode(_unref(Label), null, {
                                        default: _withCtx(() => _cache[135] || (_cache[135] = [
                                          _createTextVNode("Planos")
                                        ])),
                                        _: 1
                                      }),
                                      (paymentPlans.value)
                                        ? (_openBlock(), _createBlock(_unref(TagsInput), {
                                            key: 0,
                                            class: "px-0 gap-0 w-full",
                                            "model-value": paymentPlanNamesInDownsell.value
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_85, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentPlanNamesInDownsell.value, (name, index) => {
                                                  return (_openBlock(), _createBlock(_unref(TagsInputItem), {
                                                    key: index,
                                                    value: name
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(TagsInputItemText)),
                                                      _createVNode(_unref(TagsInputItemDelete), {
                                                        onClick: ($event: any) => {downsellForm.value.paymentPlanIds?.splice(index, 1); paymentPlanNamesInDownsell.value.splice(index, 1)}
                                                      }, null, 8, ["onClick"])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["value"]))
                                                }), 128))
                                              ]),
                                              _createVNode(_unref(ComboboxRoot), {
                                                modelValue: paymentPlanNamesInDownsell.value,
                                                "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((paymentPlanNamesInDownsell).value = $event)),
                                                open: isPaymentPlanComboboxOpen.value,
                                                "onUpdate:open": _cache[59] || (_cache[59] = ($event: any) => ((isPaymentPlanComboboxOpen).value = $event)),
                                                "search-term": searchPaymentPlan.value,
                                                "onUpdate:searchTerm": _cache[60] || (_cache[60] = ($event: any) => ((searchPaymentPlan).value = $event)),
                                                class: "w-full"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(ComboboxAnchor), { "as-child": "" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(ComboboxInput), {
                                                        placeholder: "Plano premium...",
                                                        "as-child": ""
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(TagsInputInput), {
                                                            onFocus: _cache[55] || (_cache[55] = ($event: any) => (isPaymentPlanComboboxOpen.value = true)),
                                                            class: _normalizeClass(["w-full px-3", (downsellForm.value.paymentPlanIds?.length ?? 0) > 0 ? 'mt-2' : '']),
                                                            onKeydown: _cache[56] || (_cache[56] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                                                          }, null, 8, ["class"])
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_unref(ComboboxPortal), null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(ComboboxContent), null, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(CommandList), {
                                                            position: "popper",
                                                            class: "w-[--radix-popper-anchor-width] rounded-md mt-2 border bg-popover text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_unref(CommandEmpty), null, {
                                                                default: _withCtx(() => _cache[136] || (_cache[136] = [
                                                                  _createTextVNode("Nenhum plano encontrado")
                                                                ])),
                                                                _: 1
                                                              }),
                                                              _createVNode(_unref(CommandGroup), null, {
                                                                default: _withCtx(() => [
                                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredPlansForDownsellBody.value, (plan) => {
                                                                    return (_openBlock(), _createBlock(_unref(CommandItem), {
                                                                      key: plan.id,
                                                                      value: String(plan.name),
                                                                      onSelect: _cache[57] || (_cache[57] = _withModifiers((ev) => {
                                    if (typeof ev.detail.value === 'string') {
                                      searchPaymentPlan.value = ''
                                      const p = paymentPlans.value?.data.find(pp => pp.name == ev.detail.value)
                                      if (p && !downsellForm.value.paymentPlanIds.includes(String(p.id))) {
                                        downsellForm.value.paymentPlanIds?.push(String(p.id))
                                        paymentPlanNamesInDownsell.value.push(p.name)
                                      }
                                    }
                                    
                                    if (filteredPlansForDownsellBody.value?.length === 0) {
                                      isPaymentPlanComboboxOpen.value = false
                                    }
                                  }, ["prevent"]))
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(plan.name), 1)
                                                                      ]),
                                                                      _: 2
                                                                    }, 1032, ["value"]))
                                                                  }), 128))
                                                                ]),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }, 8, ["modelValue", "open", "search-term"])
                                            ]),
                                            _: 1
                                          }, 8, ["model-value"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_86, [
                                      _createVNode(_unref(Label), null, {
                                        default: _withCtx(() => _cache[137] || (_cache[137] = [
                                          _createTextVNode("Links")
                                        ])),
                                        _: 1
                                      }),
                                      (buttons.value)
                                        ? (_openBlock(), _createBlock(_unref(TagsInput), {
                                            key: 0,
                                            class: "px-0 gap-0 w-full",
                                            "model-value": downsellButtonNames.value
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_87, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(downsellButtonNames.value, (name, index) => {
                                                  return (_openBlock(), _createBlock(_unref(TagsInputItem), {
                                                    key: index,
                                                    value: name
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(TagsInputItemText)),
                                                      _createVNode(_unref(TagsInputItemDelete), {
                                                        onClick: ($event: any) => {downsellForm.value.buttonIds?.splice(index, 1); downsellButtonNames.value.splice(index, 1)}
                                                      }, null, 8, ["onClick"])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["value"]))
                                                }), 128))
                                              ]),
                                              _createVNode(_unref(ComboboxRoot), {
                                                modelValue: downsellButtonNames.value,
                                                "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((downsellButtonNames).value = $event)),
                                                open: isButtonComboboxOpen.value,
                                                "onUpdate:open": _cache[65] || (_cache[65] = ($event: any) => ((isButtonComboboxOpen).value = $event)),
                                                "search-term": searchButton.value,
                                                "onUpdate:searchTerm": _cache[66] || (_cache[66] = ($event: any) => ((searchButton).value = $event)),
                                                class: "w-full"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(ComboboxAnchor), { "as-child": "" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(ComboboxInput), {
                                                        placeholder: "Link para landing page...",
                                                        "as-child": ""
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(TagsInputInput), {
                                                            onFocus: _cache[61] || (_cache[61] = ($event: any) => (isButtonComboboxOpen.value = true)),
                                                            class: _normalizeClass(["w-full px-3", (downsellForm.value.buttonIds?.length ?? 0) > 0 ? 'mt-2' : '']),
                                                            onKeydown: _cache[62] || (_cache[62] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                                                          }, null, 8, ["class"])
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_unref(ComboboxPortal), null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(ComboboxContent), null, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(CommandList), {
                                                            position: "popper",
                                                            class: "w-[--radix-popper-anchor-width] rounded-md mt-2 border bg-popover text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_unref(CommandEmpty), null, {
                                                                default: _withCtx(() => _cache[138] || (_cache[138] = [
                                                                  _createTextVNode("Nenhum link encontrado")
                                                                ])),
                                                                _: 1
                                                              }),
                                                              _createVNode(_unref(CommandGroup), null, {
                                                                default: _withCtx(() => [
                                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDownsellButtons.value, (btn) => {
                                                                    return (_openBlock(), _createBlock(_unref(CommandItem), {
                                                                      key: btn.id,
                                                                      value: String(btn.name),
                                                                      onSelect: _cache[63] || (_cache[63] = _withModifiers((ev) => {
                                    if (typeof ev.detail.value === 'string') {
                                      searchButton.value = ''
                                      const b = buttons.value?.data.find(bt => bt.name == ev.detail.value)
                                      if (b && !downsellForm.value.buttonIds.includes(String(b.id))) {
                                        downsellForm.value.buttonIds?.push(String(b.id))
                                        downsellButtonNames.value.push(b.name)
                                      }
                                    }
                                    
                                    if (filteredDownsellButtons.value?.length === 0) {
                                      isButtonComboboxOpen.value = false
                                    }
                                  }, ["prevent"]))
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(btn.name), 1)
                                                                      ]),
                                                                      _: 2
                                                                    }, 1032, ["value"]))
                                                                  }), 128))
                                                                ]),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }, 8, ["modelValue", "open", "search-term"])
                                            ]),
                                            _: 1
                                          }, 8, ["model-value"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_88, [
                                      _createVNode(_unref(Label), null, {
                                        default: _withCtx(() => _cache[139] || (_cache[139] = [
                                          _createTextVNode("Planos de pagamento abandonados "),
                                          _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                                        ])),
                                        _: 1
                                      }),
                                      (paymentPlans.value)
                                        ? (_openBlock(), _createBlock(_unref(TagsInput), {
                                            key: 0,
                                            class: "px-0 gap-0 w-full",
                                            "model-value": downsellPaymentPlanNames.value
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_89, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(downsellPaymentPlanNames.value, (name, index) => {
                                                  return (_openBlock(), _createBlock(_unref(TagsInputItem), {
                                                    key: index,
                                                    value: name
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(TagsInputItemText)),
                                                      (String(editingPlan.value?.id) !== String(downsellForm.value.downsellPaymentPlanIds?.[index]))
                                                        ? (_openBlock(), _createBlock(_unref(TagsInputItemDelete), {
                                                            key: 0,
                                                            onClick: ($event: any) => {downsellForm.value.downsellPaymentPlanIds?.splice(index, 1); downsellPaymentPlanNames.value.splice(index, 1)}
                                                          }, null, 8, ["onClick"]))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["value"]))
                                                }), 128))
                                              ]),
                                              _createVNode(_unref(ComboboxRoot), {
                                                modelValue: downsellPaymentPlanNames.value,
                                                "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((downsellPaymentPlanNames).value = $event)),
                                                open: isDownsellPaymentPlanComboboxOpen.value,
                                                "onUpdate:open": _cache[71] || (_cache[71] = ($event: any) => ((isDownsellPaymentPlanComboboxOpen).value = $event)),
                                                "search-term": searchDownsellPaymentPlan.value,
                                                "onUpdate:searchTerm": _cache[72] || (_cache[72] = ($event: any) => ((searchDownsellPaymentPlan).value = $event)),
                                                class: "w-full"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(ComboboxAnchor), { "as-child": "" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(ComboboxInput), {
                                                        placeholder: "Plano premium...",
                                                        "as-child": ""
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(TagsInputInput), {
                                                            onFocus: _cache[67] || (_cache[67] = ($event: any) => (isDownsellPaymentPlanComboboxOpen.value = true)),
                                                            class: _normalizeClass(["w-full px-3", (downsellForm.value.downsellPaymentPlanIds?.length ?? 0) > 0 ? 'mt-2' : '']),
                                                            onKeydown: _cache[68] || (_cache[68] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                                                          }, null, 8, ["class"])
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_unref(ComboboxPortal), null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(ComboboxContent), null, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(CommandList), {
                                                            position: "popper",
                                                            class: "w-[--radix-popper-anchor-width] rounded-md mt-2 border bg-popover text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_unref(CommandEmpty), null, {
                                                                default: _withCtx(() => _cache[140] || (_cache[140] = [
                                                                  _createTextVNode("Nenhum plano encontrado")
                                                                ])),
                                                                _: 1
                                                              }),
                                                              _createVNode(_unref(CommandGroup), null, {
                                                                default: _withCtx(() => [
                                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDownsellPaymentPlans.value, (plan) => {
                                                                    return (_openBlock(), _createBlock(_unref(CommandItem), {
                                                                      key: plan.id,
                                                                      value: String(plan.name),
                                                                      onSelect: _cache[69] || (_cache[69] = _withModifiers((ev) => {
                                    if (typeof ev.detail.value === 'string') {
                                      searchDownsellPaymentPlan.value = ''
                                      const p = paymentPlans.value?.data.find(pp => pp.name == ev.detail.value)
                                      if (p && !downsellForm.value.downsellPaymentPlanIds.includes(String(p.id))) {
                                        downsellForm.value.downsellPaymentPlanIds?.push(String(p.id))
                                        downsellPaymentPlanNames.value.push(p.name)
                                      }
                                    }
                                    
                                    if (filteredDownsellPaymentPlans.value?.length === 0) {
                                      isDownsellPaymentPlanComboboxOpen.value = false
                                    }
                                  }, ["prevent"]))
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(plan.name), 1)
                                                                      ]),
                                                                      _: 2
                                                                    }, 1032, ["value"]))
                                                                  }), 128))
                                                                ]),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }, 8, ["modelValue", "open", "search-term"])
                                            ]),
                                            _: 1
                                          }, 8, ["model-value"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_90, [
                                      _createVNode(_unref(Label), null, {
                                        default: _withCtx(() => _cache[141] || (_cache[141] = [
                                          _createTextVNode("Intervalo de envio após abandono "),
                                          _createElementVNode("span", { class: "text-red-500" }, "*", -1),
                                          _createTextVNode(" (horas e minutos)")
                                        ])),
                                        _: 1
                                      }),
                                      _createVNode(TimePicker, {
                                        modelValue: downsellIntervalTime.value,
                                        "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((downsellIntervalTime).value = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_91, [
                                      _createVNode(_unref(Switch), {
                                        checked: downsellForm.value.abandonedChat,
                                        "onUpdate:checked": _cache[74] || (_cache[74] = ($event: any) => ((downsellForm.value.abandonedChat) = $event))
                                      }, null, 8, ["checked"]),
                                      _createElementVNode("div", _hoisted_92, [
                                        _createVNode(_unref(Label), { class: "text-sm" }, {
                                          default: _withCtx(() => _cache[142] || (_cache[142] = [
                                            _createTextVNode("Abandono de Carrinho (Chat)")
                                          ])),
                                          _: 1
                                        }),
                                        _cache[143] || (_cache[143] = _createElementVNode("span", { class: "text-[10px] text-zinc-500" }, "Enviar mesmo para quem não gerou pix.", -1))
                                      ])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_93, [
                                  _createVNode(_unref(Button), {
                                    variant: "ghost",
                                    size: "sm",
                                    class: "text-zinc-400 hover:text-white",
                                    onClick: cancelDownsellEdit
                                  }, {
                                    default: _withCtx(() => _cache[144] || (_cache[144] = [
                                      _createTextVNode("Cancelar")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_unref(Button), {
                                    size: "sm",
                                    disabled: isSavingDownsell.value || !downsellForm.value.description || !downsellForm.value.message,
                                    onClick: saveDownsell
                                  }, {
                                    default: _withCtx(() => [
                                      (isSavingDownsell.value)
                                        ? (_openBlock(), _createBlock(_unref(Loader2), {
                                            key: 0,
                                            class: "size-4 animate-spin mr-2"
                                          }))
                                        : _createCommentVNode("", true),
                                      _createTextVNode(" " + _toDisplayString(editingDownsellId.value ? 'Salvar alterações' : 'Cadastrar downsell'), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_94, [
                            _createVNode(Table, null, {
                              default: _withCtx(() => [
                                _createVNode(TableHeader, { class: "bg-zinc-900/50" }, {
                                  default: _withCtx(() => [
                                    _createVNode(TableRow, null, {
                                      default: _withCtx(() => [
                                        _createVNode(TableHead, { class: "text-[10px] uppercase font-bold text-zinc-500" }, {
                                          default: _withCtx(() => _cache[145] || (_cache[145] = [
                                            _createTextVNode("Descrição")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(TableHead, { class: "text-[10px] uppercase font-bold text-zinc-500" }, {
                                          default: _withCtx(() => _cache[146] || (_cache[146] = [
                                            _createTextVNode("Intervalo")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(TableHead, { class: "text-[10px] uppercase font-bold text-zinc-500" }, {
                                          default: _withCtx(() => _cache[147] || (_cache[147] = [
                                            _createTextVNode("Status")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(TableHead, { class: "text-[10px] uppercase font-bold text-zinc-500 text-right" }, {
                                          default: _withCtx(() => _cache[148] || (_cache[148] = [
                                            _createTextVNode("Ações")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(TableBody, null, {
                                  default: _withCtx(() => [
                                    (editingPlan.value?.downsells && editingPlan.value.downsells.length > 0)
                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(editingPlan.value.downsells, (ds) => {
                                          return (_openBlock(), _createBlock(TableRow, {
                                            key: ds.id,
                                            class: "hover:bg-zinc-900/30 transition-colors"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(TableCell, { class: "text-xs font-medium text-white" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(ds.description), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(TableCell, { class: "text-xs text-zinc-400 font-mono" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_unref(intervalToHHMM)(ds.sendingInterval)), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(TableCell, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(Badge), {
                                                    variant: "outline",
                                                    class: _normalizeClass(ds.status === 'active' ? 'border-emerald-500/20 text-emerald-400 bg-emerald-500/5' : 'border-zinc-800 text-zinc-500')
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(ds.status === 'active' ? 'Ativo' : 'Inativo'), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["class"])
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(TableCell, { class: "text-right" }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("div", _hoisted_95, [
                                                    _createVNode(_unref(Button), {
                                                      variant: "ghost",
                                                      size: "icon",
                                                      class: "size-8 text-zinc-500 hover:text-white hover:bg-zinc-800",
                                                      onClick: ($event: any) => (editDownsell(ds))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_unref(PencilIcon), { class: "size-4" })
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClick"]),
                                                    _createVNode(_unref(Button), {
                                                      variant: "ghost",
                                                      size: "icon",
                                                      class: "size-8 text-zinc-500 hover:text-red-400 hover:bg-red-400/10",
                                                      onClick: ($event: any) => (removeDownsell(ds.id))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_unref(Trash), { class: "size-4" })
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClick"])
                                                  ])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      : (_openBlock(), _createBlock(TableRow, { key: 1 }, {
                                          default: _withCtx(() => [
                                            _createVNode(TableCell, {
                                              colspan: "4",
                                              class: "h-32 text-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_96, [
                                                  _createVNode(_unref(ArrowDown), { class: "size-6 text-zinc-700" }),
                                                  _cache[149] || (_cache[149] = _createElementVNode("span", { class: "text-xs text-zinc-500" }, "Nenhuma mensagem de downsell configurada.", -1))
                                                ])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : (_openBlock(), _createBlock(_unref(Loader2), {
                  key: 1,
                  class: "w-10 h-10 animate-spin text-white mx-auto"
                })),
            _createVNode(_unref(DialogFooter), { class: "-full" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Button), {
                  variant: "ghost",
                  class: "text-white",
                  onClick: closePlanDialog
                }, {
                  default: _withCtx(() => _cache[150] || (_cache[150] = [
                    _createTextVNode("Cancelar")
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  disabled: isSaving.value || (!planForm.value.name || !planForm.value.type || !planForm.value.amount || !planForm.value.status || (upsell.value && !planForm.value.upsellMessage) || (!planForm.value.cycle && planForm.value.type !== _unref(PaymentPlanTypeEnum).LIFETIME)),
                  onClick: savePlan
                }, {
                  default: _withCtx(() => [
                    (isSaving.value)
                      ? (_openBlock(), _createBlock(_unref(Loader2), {
                          key: 0,
                          class: "w-4 h-4 animate-spin"
                        }))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(editingPlan.value ? 'Salvar alterações' : 'Criar plano'), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(DeleteConfirmationDialog, {
      open: isDeleteDownsellDialogOpen.value,
      "onUpdate:open": _cache[77] || (_cache[77] = ($event: any) => ((isDeleteDownsellDialogOpen).value = $event)),
      loading: isDeletingDownsell.value,
      title: "Remover Downsell",
      description: "Tem certeza que deseja remover esta mensagem de downsell? Esta ação não pode ser desfeita.",
      onConfirm: confirmDeleteDownsell
    }, null, 8, ["open", "loading"])
  ], 64))
}
}

})